module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ai-e30aaaa58e5ec31a4b7b72d539442208.svg";